/**
 * Curated Unsplash image library for Wowrolla.
 * All images are free-to-use via Unsplash public CDN with no API key required.
 * Grouped by theme for consistent visual language across the site.
 */

import lightBackground from '../images/lightbackground.jpg';
import taraWinstead from '../images/pexels-tara-winstead-8849282.jpg';
import robotPlatform from '../images/robotplattform.jpg';
import robotStandingBottom from '../images/robotstandingbottom.jpg';

export const IMG = {
  /* â”€â”€ Hero & landscape backgrounds â”€â”€ */
  hero: {
    aiWorkspace:    'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=1800&q=85',
    dataNetwork:    robotPlatform,
    techDesk:       'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1800&q=85',
    glowCircuit:    'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=1800&q=85',
    codeAbstract:   robotPlatform,
    teamCollaborate:'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1800&q=85',
    neonCity:       'https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1800&q=85',
    darkGrid:       'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1800&q=85',
    floatingNodes:  'https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6?auto=format&fit=crop&w=1800&q=85',
    serverRack:     'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1800&q=85',
    buyingDecision: '/images/robotkid.jpg',
    analytics:      'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&w=1800&q=85',
    workspace:      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1800&q=85',
    search:         robotPlatform,
    blog:           taraWinstead,
    compare:        '/images/compare.jpg',
    transparency:   'https://images.unsplash.com/photo-1526628953301-3cd48e5a9e2d?auto=format&fit=crop&w=1800&q=85',
    stack:          robotPlatform,
    consulting:     'https://images.unsplash.com/photo-1531973576160-7125cd663d86?auto=format&fit=crop&w=1800&q=85',
    newsletter:     '/images/handtohand.jpg',
    finder:         'https://images.unsplash.com/photo-1595675024853-0f3ec9098ac7?auto=format&fit=crop&w=1800&q=85',
    trophyAward:    'https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&w=1800&q=85',
    alternatives:   robotStandingBottom,
    categoriesBackdrop: lightBackground,
  },

  /* â”€â”€ Side / card panels (square-ish) â”€â”€ */
  card: {
    aiDashboard:  'https://images.unsplash.com/photo-1686061593213-98dadb3d4f74?auto=format&fit=crop&w=800&q=80',
    teamPlanning: 'https://images.unsplash.com/photo-1633419461186-7d40a38105ec?auto=format&fit=crop&w=800&q=80',
    devSetup:     'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?auto=format&fit=crop&w=800&q=80',
    meetingRoom:  'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80',
    dataDriven:   'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80',
    graphGrowth:  'https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80',
    focusWork:    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80',
    productTool:  'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80',
    codeScreen:   robotPlatform,
  },

  /* â”€â”€ Category-themed pool (indexed by category position) â”€â”€ */
  categories: [
    'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?auto=format&fit=crop&w=600&q=75', // AI chat
    'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?auto=format&fit=crop&w=600&q=75', // analytics
    'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&w=600&q=75', // graphs
    'https://images.unsplash.com/photo-1603302576837-37561b2e2302?auto=format&fit=crop&w=600&q=75', // dev tools
    'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=600&q=75', // team
    'https://images.unsplash.com/photo-1526628953301-3cd48e5a9e2d?auto=format&fit=crop&w=600&q=75', // data
    'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=600&q=75', // office
    'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=600&q=75', // creative
  ],
};

/** Returns a consistent Unsplash category image for a given index */
export const getCategoryImg = (index) =>
  IMG.categories[index % IMG.categories.length];

const CATEGORY_HERO_BY_SLUG = {
  'ai-agents': IMG.hero.glowCircuit,
  'chatbots-agents': IMG.hero.glowCircuit,
  'writing-assistants': IMG.hero.workspace,
  'image-generators': IMG.hero.aiWorkspace,
  'image-generation': IMG.hero.aiWorkspace,
  'video-creation': IMG.hero.teamCollaborate,
  'code-assistants': IMG.hero.codeAbstract,
  'seo-tools': IMG.hero.analytics,
  'seo-marketing': IMG.hero.analytics,
  'workflow-automation': IMG.hero.serverRack,
  'audio-music': IMG.hero.blog,
  'audio-voice': IMG.hero.blog,
  'data-analysis': IMG.hero.analytics,
  'data-analytics': IMG.hero.analytics,
  'email-productivity': IMG.hero.finder,
  'productivity': IMG.hero.finder,
  'marketing-ads': IMG.hero.teamCollaborate,
  '3d-design': IMG.hero.neonCity,
  design: IMG.hero.neonCity,
  'translation-languages': IMG.hero.transparency,
  'operations-tracking': IMG.hero.darkGrid,
  'customer-support': IMG.hero.finder,
  research: IMG.hero.search,
  'sales-crm': IMG.hero.buyingDecision,
};

export const getCategoryHeroImgBySlug = (slug, index = 0) => {
  const normalized = String(slug || '').toLowerCase().trim();
  if (normalized && CATEGORY_HERO_BY_SLUG[normalized]) {
    return CATEGORY_HERO_BY_SLUG[normalized];
  }
  return getCategoryImg(index);
};

